import { ForgeAutomationRunDetail } from "./ForgeAutomationRunDetail";
import { useForgeAutomationRunDetail } from "./useForgeAutomationRunDetail";

export interface ForgeAutomationRunRouteProps {
  readonly runId: number;
  readonly organizationId: string;
  readonly onBack: () => void;
  readonly onChanged: () => void;
}

export function ForgeAutomationRunRoute({
  runId,
  organizationId,
  onBack,
  onChanged,
}: ForgeAutomationRunRouteProps) {
  const state = useForgeAutomationRunDetail(runId, organizationId, onChanged);
  return (
    <ForgeAutomationRunDetail
      detail={state.detail}
      loading={state.loading}
      error={state.error}
      busyAction={state.busyAction}
      onBack={onBack}
      onRefresh={() => void state.refresh()}
      onRetry={state.retry}
      onCancel={state.cancel}
      onApprove={state.approve}
      onReject={state.reject}
    />
  );
}
